import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import usePageProps from '@/routes/usePageProps';
import StoreAssociationPage from '@/pages/StoreAssociationPage';

const StoreAssociation: React.FC<RouteComponentProps> = props => {
  const pageProps = usePageProps({ props });

  if (pageProps.reducersState.app.loadingPlatformConfig) {
    return null;
  }

  return <StoreAssociationPage {...pageProps} />
};

export default StoreAssociation;
